import React, { memo, useMemo } from 'react'
import classnames from 'classnames'
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded'

export interface BackButtonProps {
  onClick: () => void
  disabled?: boolean
  isHighlighted?: boolean
  animate?: boolean
  variant?: 'desktop' | 'mobile'
  className?: string
}

const baseButtonStyle: React.CSSProperties = {
  cursor: 'pointer',
  opacity: '1',
}

const BackButtonComponent: React.FC<BackButtonProps> = ({
  onClick,
  disabled,
  isHighlighted,
  animate,
  variant = 'desktop',
  className,
}) => {
  const iconStyle = useMemo<React.CSSProperties>(() => {
    return variant === 'mobile' ? { fontSize: '4vh', color: '#ffffff' } : { fontSize: '4vh' }
  }, [variant])

  const buttonClassName = classnames(
    {
      'is-highlighted': !!isHighlighted,
      'back-button-animation': !!animate,
    },
    className,
  )

  return (
    <button onClick={onClick} disabled={disabled} className={buttonClassName} style={baseButtonStyle}>
      <ArrowBackIosRoundedIcon style={iconStyle} />
    </button>
  )
}

export const BackButton = memo(BackButtonComponent)
